export default __webpack_public_path__ + "9dfbf9b0599eb0c7a6fd09af50765fcd.jpg";